import React, { useMemo } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { AccountMini } from '../AccountMini/accountMini';
import { useBlockchainProvider } from '../../providers/Blockchain/blockchainProvider';
import { WalletWhiteIcon } from '../../common/components/icons/wallet_white';

enum CONNECT_TYPES {
	EMPTY,
	NOT_LOGGED,
	LOGGED,
}

export const WalletElement = ({ isMobile, t }: { isMobile: boolean; t: any }) => {
	const { isLoggedIn, isEthereum, login } = useBlockchainProvider();

	const typeOptions = {
		[CONNECT_TYPES.EMPTY]: () => <Flex />,
		[CONNECT_TYPES.LOGGED]: () => <AccountMini isMobile={isMobile} />,
		[CONNECT_TYPES.NOT_LOGGED]: () => (
			<Flex
				onClick={login}
				alignItems="center"
				cursor="pointer"
			>
				{!isMobile && (
					<Text
						whiteSpace="nowrap"
						fontSize="16px"
						fontWeight="600"
						mr="6px"
					>
						{t('default.connect').toString()}
					</Text>
				)}
				<Box maxH="20px">
					<WalletWhiteIcon />
				</Box>
			</Flex>
		),
	};

	const connectType = useMemo(() => {
		if (!isEthereum) {
			return CONNECT_TYPES.EMPTY;
		}
		if (isLoggedIn) {
			return CONNECT_TYPES.LOGGED;
		}
		return CONNECT_TYPES.NOT_LOGGED;
	}, [isEthereum, isLoggedIn]);

	return <>{typeOptions[connectType]()}</>;
};
